import React, { useContext } from 'react';
import { FocusBaseContext } from '../../contexts';
import MultiSummaryPanelWithEditing from "./multiSummaryPanelWithEditing";
import AllSummaries from "./allSummaries";
import MarkupReports from './reports';
import TotalRespondents from './totalRespondents';
import FiltersRow from './filtersRow';
import TabsAndRegions from './tabsAndRegions';
import LeftPartWithImage from './leftPartWithImage';
import RightPart from './rightPart';
import SummaryViews from './summaryViews';
import MarkupDataProvider from './markupDataProvider';

const MarkupData = () => {
  const { focus } = useContext(FocusBaseContext);

  return (
    <MarkupDataProvider>
      <div className="page-section -flex-between cf-section">
        <h3>Concept Focus Results</h3>
        <MarkupReports />
      </div>
      { !focus.need_swipe && <TotalRespondents /> }

      <AllSummaries />

      <FiltersRow />

      <MultiSummaryPanelWithEditing />

      <TabsAndRegions />
      <div className="summary-markup_reactions">
        <LeftPartWithImage />
        <RightPart />
      </div>
      <SummaryViews />
    </MarkupDataProvider>
  );
};

export default MarkupData;
